export enum OffcanvasPanelSizeEnum {
    Original,
    FullScreen
}
